<template>
  <b-progress
    v-if="user && user.is_hijacked_by_staff"
    :value="100"
    :max="100"
    variant="warning"
    striped
    height="4rem"
  >
    <b-progress-bar :value="100">
      <span class="alert-text">
        You are currently working on behalf of {{ user.first_name }}
        {{ user.last_name }} | {{ user.email }}
        <LogoutButton class="btn bg-white" :show-icon="false" @logout="onLogout">
          Release {{ user.first_name }} {{ user.last_name }}
        </LogoutButton>
      </span>
    </b-progress-bar>
  </b-progress>
</template>

<script>
import LogoutButton from "@/components/site/common/LogoutButton.vue";
import { mapState } from "vuex";

export default {
  components: { LogoutButton },
  computed: {
    ...mapState(["user"]),
  },
  methods: {
    onLogout() {
      window.close();
    },
  },
};
</script>

<style>
.alert-text {
  color: black;
  font-size: 1rem;
}
</style>
